var Backbone = require("backbone");

	var livingplace_misc = Backbone.Model.extend({
	    defaults: {
	    	searchxy: []
	    }
});

module.exports = livingplace_misc


// WEBPACK FOOTER //
// ./src/models/lpmiscstates.js